import {
  TwoFactorMethod,
  TwoFactorResendResponse,
} from "@/types/TwoFactorTypes";
import WebshareApi from "..";

// https://apidocs.webshare.io/twofactorauth/resend-2fa-email
export const resendTwoFactorAuthCode = () =>
  WebshareApi.post<TwoFactorResendResponse>("/twofactorauth/email/resend/");

// https://apidocs.webshare.io/twofactorauth/activate-2fa-method
export const activateTwoFactorMethod = (
  id: string,
  code1: string,
  code2: string
) =>
  WebshareApi.post<TwoFactorMethod>(`/twofactorauth/method/${id}/activate/`, {
    code1,
    code2,
  });

// https://apidocs.webshare.io/twofactorauth/change-2fa-method
export const changeTwoFactorMethod = (
  methodType: "email_code" | "device_totp"
) =>
  WebshareApi.post<TwoFactorMethod>(`/twofactorauth/method/`, {
    type: methodType,
  });

// https://apidocs.webshare.io/twofactorauth/get-2fa-method
export const getTwoFactorMethod = () =>
  WebshareApi.get<TwoFactorMethod>(`/twofactorauth/method/current/`);

// https://apidocs.webshare.io/twofactorauth/enter-2fa-code
export const enterTwoFactorCode = (code: string, recaptcha?: string | null) =>
  WebshareApi.post<{}>(`/twofactorauth/codeauth/`, {
    code,
    recaptcha,
  });
